export const CLIENT_SYNTHESIS_DISPLAY_NAME = 'Client Synthesis';

export const getClientSynthesisPdfFilename = (clientName) => {
  const safeName = String(clientName || '')
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || 'Client';
  return `INSIGHT_Client_Synthesis_${safeName}.pdf`;
};
